<template>
  <fragment>
    <c-hero-split class="illustration-section-01" />
    <c-clients top-divider bottom-divider />
    <c-generic-section top-divider class="center-content">
      <c-section-header id="welcome" :data="genericSection01Header" class="reveal-from-bottom" />
      <c-button color="primary" tag="router-link" to="/how-it-works">How it works, Step By Step</c-button>

      <!-- <div class="reveal-from-bottom">
        <a
          data-video="https://player.vimeo.com/video/174002812"
          href="#"
          aria-controls="video-modal"
          @click.prevent="videoModalActive = true"
        >
          <c-image
            :src="require('@/assets/images/video-placeholder.svg')"
            alt="Video"
            :width="712"
            :height="400"
          />
        </a>
      </div>
      <c-modal
        id="video-modal"
        :active.sync="videoModalActive"
        video="https://player.vimeo.com/video/174002812"
        video-tag="iframe"
      />-->
    </c-generic-section>
    <c-features-tiles top-divider class="center-content" />
    <c-testimonial top-divider />
    <c-cta split />
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutDefault.vue";
// import section header
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
// import sections
import CHeroSplit from "@/components/sections/HeroSplit.vue";
import CClients from "@/components/sections/Clients.vue";
import CGenericSection from "@/components/sections/GenericSection.vue";
import CFeaturesTiles from "@/components/sections/FeaturesTiles.vue";
import CTestimonial from "@/components/sections/Testimonial.vue";
import CCta from "@/components/sections/Cta.vue";
// import some reuqired elements
import CButton from "@/components/elements/Button.vue";
// import CImage from "@/components/elements/Image.vue";
// import CModal from "@/components/elements/Modal.vue";

export default {
  name: "Home",
  components: {
    CSectionHeader,
    CHeroSplit,
    CClients,
    CGenericSection,
    CFeaturesTiles,
    CTestimonial,
    CCta,
    CButton
    // CImage,
    // CModal
  },
  data() {
    return {
      genericSection01Header: {
        title:
          "I'll help you scope your client's project, understand their problem domain, and deploy a solution in under 45 calendar days.",
        paragraph:
          "Your client has a concept in mind and maybe a pitch deck. But what they really need is a working prototype to develop customers, impress investors, and grow their business. You can help them build it."
      },
      videoModalActive: false
    };
  },
  created() {
    this.$emit("update:layout", CLayout);
  }
};
</script>
